export default "__VITE_ASSET__WrRUjGBE__"